<template>
  <svg height="250" width="200" class="figure-container">
    <line v-if="wrongCount >= 1" x1="20" y1="230" x2="100" y2="230" />
    <line v-if="wrongCount >= 2" x1="60" y1="20" x2="60" y2="230" />
    <line v-if="wrongCount >= 3" x1="60" y1="20" x2="140" y2="20" />
    <line v-if="wrongCount >= 4" x1="140" y1="20" x2="140" y2="50" />
    <circle v-if="wrongCount >= 5" cx="140" cy="70" r="20" />
    <line v-if="wrongCount >= 6" x1="140" y1="90" x2="140" y2="150" />
    <line v-if="wrongCount >= 7" x1="140" y1="120" x2="120" y2="100" />
    <line v-if="wrongCount >= 8" x1="140" y1="120" x2="160" y2="100" />
    <line v-if="wrongCount >= 9" x1="140" y1="150" x2="120" y2="180" />
    <line v-if="wrongCount >= 10" x1="140" y1="150" x2="160" y2="180" />
  </svg>
</template>

<script>
export default {
  props: {
    wrongCount: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style>

.figure-container {
  fill: transparent;
  stroke: red;
  stroke-width: 4px;
  stroke-linecap: round;
}

.figure-part {
  display: none;
}
</style>
